// const newExercise = (attributes) => {
//   return { multiplier: 1, ...attributes }
// }

// const newChromatism = (signature, attributes = {}) => {
//   return newExercise({
//     signature: signature,
//     count: 100,
//     ...attributes
//   })
// }

const Test = () => {
  // const exercises = [
  //   { signature: '4123', count: 100, multiplier: 1 },
  //   { signature: '4123 - Jump Fret: 2-3', count: 100, multiplier: 0.85 },
  //   { signature: 'Right: 12 Mizinha', count: 100, multiplier: 1.2 },
  //   { signature: '2413', count: 100, multiplier: 1 },
  //   { signature: '2413 - Stairs: Right Down', count: 100, multiplier: 0.85 },
  //   { signature: 'Right: B-C', count: 100, multiplier: 1.2 },
  //   { signature: '1342', count: 100, multiplier: 0.85 }
  // ]

  return null
}

export default Test
